import React from 'react';
import {
  getHubFamily,
  isHubRenderable,
} from '../../utils/entityHubRenderable';
import { personHubHasSurface } from '../../utils/personHeroCover';
import SportsHub from './SportsHub.jsx';
import PersonHub from './PersonHub.jsx';
import './entityHub.css';

/**
 * Entity Hub shell — renders sports/person layouts from a hub payload.
 * Never blocks the results gallery; returns null when empty or on error.
 */
function EntityHub({ entityId, results = [], hub = null }) {
  const family = getHubFamily(hub);
  const show = family === 'person'
    ? personHubHasSurface(hub, results)
    : isHubRenderable(hub);
  if (!show) return null;

  return (
    <section className="entity-hub" aria-label="Entity hub">
      {family === 'person' ? (
        <PersonHub
          hub={hub}
          results={results}
          entityId={entityId || hub?.entity?.id}
        />
      ) : (
        <SportsHub
          hub={hub}
          entityId={entityId || hub?.entity?.id}
          results={results}
        />
      )}
    </section>
  );
}

export default EntityHub;
